module.exports = __webpack_public_path__ + "img/LV.c75ac231.svg";